import React, { useState } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import OngoingNanny from './OngoingNanny';
import UpcomingNanny from './UpcomingNanny';
import PastNanny from './PastNanny';

const Nannybooking = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [resetKey, setResetKey] = useState(0);

  const handleTabChange = (index) => {
    setTabIndex(index);
    setResetKey(prev => prev + 1); // triggers re-render of components
  };

  return (
    <div>
      <div className="row order_card mb-5">
        <Tabs selectedIndex={tabIndex} onSelect={handleTabChange}>
          <TabList>
            <Tab>ON GOING</Tab>
            <Tab>UPCOMING</Tab>
            <Tab>PAST</Tab>
          </TabList>

          <TabPanel>
            <OngoingNanny key={`ongoing-${resetKey}`} />
          </TabPanel>
          <TabPanel>
            <UpcomingNanny key={`upcoming-${resetKey}`} />
          </TabPanel>
          <TabPanel>
            <PastNanny key={`past-${resetKey}`} />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};

export default Nannybooking;
